import React from "react";
import { Modal, Typography } from "antd";
import { useFetchApi } from "../../hooks/useFetchApi";

const { Title, Text } = Typography;

const DeleteModal: React.FC<{
  id: string | number;
  data: any;
  status: boolean;
  onClose: any;
  onSuccess: any;
}> = ({ data, status, onClose, onSuccess }): React.ReactElement => {
  const { execute } = useFetchApi("/api/equations", {}, "DELETE", onSuccess);

  const handleSubmit = (e: any) => {
    execute({ id: data.id });
    const _e = { ...e, target: { ...e.target, id: "delete" } };
    onClose(_e);
  };

  const handleClose = (e: any) => {
    const _e = { ...e, target: { ...e.target, id: "delete" } };
    onClose(_e);
  };

  return (
    <Modal
      open={status}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText="Delete"
      okButtonProps={{ danger: true }}
      cancelText="Cancel"
      centered
      width={360}
    >
      <Title level={5} className="text-center">
        Are you sure you want to delete ?
      </Title>
      <Text className="block text-center mt-4 mb-4">
        This action is irreversible
      </Text>
    </Modal>
  );
};

export default DeleteModal;
